module.exports = __webpack_public_path__ + "img/employers-main.fb79c732.jpg";